var Conversation = (function(Conversation) {

  function Sender(el) {
    this.el = $(el);
    this.attachEvents();
  }


  Sender.prototype.attachEvents = function() {
    var form = this.el;

    form.on('submit', function(ev) {
      ev.preventDefault();
      var data = serializeForm(form);

      // Don't bother if there's no message body
      if ($.trim(data['message[body]']) == '') {
        return;
      }

      var message_id = Conversation.Thread.addMessage(data);

      // Clean up the form
      form[0].reset();

      $.ajax({
        method: 'POST',
        url: form.attr('action'),
        data: data,
        dataType: 'json'
      }).done(function() {
        Conversation.Thread.markAsSent(message_id);
      });

    });
  };


  // Stolen from http://stackoverflow.com/a/1186309/508684
  function serializeForm(form) {
    var o = {};
    $.each(form.serializeArray(), function() {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });
    return o;
  }

  Conversation.Sender = Sender;
  return Conversation;

})(Conversation || {});
